<template>
  <v-container fluid>
    <v-row
      justify="center"
      align="center"
      class="stripe py-5"
      style="margin-top: 20vh;"
    >
      <div class="text-center">
        <color-input v-model="colors.teamA" label="Color team A"></color-input>
        <color-input v-model="colors.teamB" label="Color team B"></color-input>
        <v-select v-model="wordListIndex" :items="languages"></v-select>
        <v-btn depressed @click="host" color="primary">Host a game</v-btn>
      </div>
    </v-row>
  </v-container>
</template>

<style scoped>
.stripe {
  border: 10px solid #a4bcd4;
  border-left: 0;
  border-right: 0;
  background: #fcfafa;
}
</style>

<script>
import colors from '../utils/colors';
import textColor from '../utils/textColor';
import wordList from '../utils/words';

export default {
  name: 'Home',
  props: {
    server: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      colors: colors,
      wordListIndex: 0,
      languages: wordList.map((item, index) => {
        return { text: item.language, value: index };
      }),
    };
  },
  methods: {
    host() {
      this.server.setColorTeamA(this.colors.teamA);
      this.server.setColorTeamB(this.colors.teamB);

      this.server.setWordList(
        wordList[this.wordListIndex].words.split(',').map((word) => word.trim())
      );

      this.server.create((id) => {
        this.$router.push({ name: 'Client', params: { destPeerId: id } });
      });
    },
    setColorTeamA(color) {
      this.colors.teamA = color.hex;
    },
    setColorTeamB(color) {
      this.colors.teamB = color.hex;
    },
    closeColorPickerTeamA() {
      this.colorPickerTeamAOpen = false;
    },
    closeColorPickerTeamB() {
      this.colorPickerTeamBOpen = false;
    },
    textColor: textColor,
  },
};
</script>
